import React, { FC, useEffect, useState, useRef } from 'react'
import { mobileContentContainer, templateContentContainer } from './styles';
import { TemplateProps } from './types';
import { Layout, TemplateScrollbar } from '@components';
import { motion } from 'motion/react';
import { useSpring } from 'framer-motion';
import { useColorStore } from '@provider';
import TemplateNextContent from './components/TemplateNextContent';
import { useMediaQuery } from 'usehooks-ts';


const Template: FC<TemplateProps> = ({
    children,

}) => {
    const [x, setX] = useState(0);
    const xMotion = useSpring(0, { stiffness: 300, damping: 30 });
    const contentRef = useRef<HTMLDivElement>(null);
    const parentRef = useRef<HTMLDivElement>(null);
    const {setRightContentColor, setLeftContentColor} = useColorStore();
    const [scrollWidth, setScrollWidth] = useState<number>(0);
    const scrollEndTimeout = useRef<NodeJS.Timeout | null>(null);
    const isTableOrMobile = useMediaQuery('(max-width: 768px)');

    useEffect(() => {
      xMotion.set(x);
    }, [x, xMotion]);

    function updatePositions() {
      const innerWidth = window.innerWidth;
      const startEl = document.getElementById('dark-content-start');
      const endEl = document.getElementById('dark-content-end');
      const startX = startEl ? startEl.getBoundingClientRect().left - innerWidth : null;
      const endX = endEl ? endEl.getBoundingClientRect().left - innerWidth : null;
      
      if (startX === null || endX === null) return;
      
      if (endX < -230) {
          setRightContentColor('dark');
      } else if (endX > 0 && startX < -50) {
          setRightContentColor('light');
      } else {
          setRightContentColor('dark');
      }
      if (endX < -(innerWidth - 100) ) {
          setLeftContentColor('dark');
      } else if (startX < (50 - innerWidth)) {
          setLeftContentColor('light');
      } else {
          setLeftContentColor('dark');
      }
    }

    useEffect(() => {
      const handleScroll = (e: WheelEvent | KeyboardEvent | TouchEvent) => {
        let delta = 0;
        if (e instanceof WheelEvent) {
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            delta = e.deltaY;
          }
        } else if (e instanceof KeyboardEvent) {
          if (['ArrowLeft', 'ArrowUp'].includes(e.key)) delta = -100;
          if (['ArrowRight', 'ArrowDown'].includes(e.key)) delta = 100;
        } else if (e instanceof TouchEvent && e.touches.length === 1) {
          const touchStartX = e.touches[0].pageX;
          let previousPageX = touchStartX;

          const handleTouchMove = (moveEvent: TouchEvent) => {
            if (moveEvent.touches.length !== 1) return;

            const currentPageX = moveEvent.touches[0].pageX;
            delta = previousPageX - currentPageX;
            previousPageX = currentPageX; // Update previous position

            if (delta !== 0 && contentRef.current && parentRef.current) {
              setX((prev) => {
                const maxScroll = contentRef.current!.scrollWidth - parentRef.current!.clientWidth;
                let next = prev - delta;
                next = Math.max(Math.min(next, 0), -maxScroll);
                return next;
              });
            }
            e.preventDefault?.();
          };

      const handleTouchEnd = () => {
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);

        // Debounce updatePositions after scroll ends
        if (scrollEndTimeout.current) clearTimeout(scrollEndTimeout.current);
        scrollEndTimeout.current = setTimeout(() => {
          updatePositions();
        }, 120);
      };

      window.addEventListener('touchmove', handleTouchMove, { passive: false });
      window.addEventListener('touchend', handleTouchEnd);

    
      };

        if (delta !== 0 && contentRef.current && parentRef.current) {
          e.preventDefault?.();
          setX((prev) => {
            const maxScroll = contentRef.current!.scrollWidth - parentRef.current!.clientWidth;
            let next = prev - delta;
            next = Math.max(Math.min(next, 0), -maxScroll);
            return next;
          });
          // Debounce updatePositions after scroll ends
          if (scrollEndTimeout.current) clearTimeout(scrollEndTimeout.current);
          scrollEndTimeout.current = setTimeout(() => {
            updatePositions();
          }, 120);
        }
      };
      const node = parentRef.current;
      if (node) {
        node.addEventListener('wheel', handleScroll, { passive: false });
        node.addEventListener('touchstart', handleScroll, { passive: false });
      }
      window.addEventListener('keydown', handleScroll);

      return () => {
         if (node) {
          node.removeEventListener('wheel', handleScroll);
          node.removeEventListener('touchstart', handleScroll);
        }
        window.removeEventListener('keydown', handleScroll);

        if (scrollEndTimeout.current) clearTimeout(scrollEndTimeout.current);
      };
    }, []);


    
    useEffect(() => {
        if (contentRef.current) {
            setScrollWidth(contentRef.current.scrollWidth - window.innerWidth);
        }
    }, [contentRef.current]);

    if (isTableOrMobile) return (
      <Layout>
        <div css={mobileContentContainer}>
          {children}
        </div>

      </Layout>
    
    );

    return (
        <>
            <Layout>
                <div ref={parentRef} style={{ width: '100vw', overflow: 'hidden', height: '100vh', position: 'fixed', top: 0, left: 0, zIndex: 2 }} >
                    <motion.div
                        id="templateContentContainer"
                        ref={contentRef}
                        css={templateContentContainer}
                        style={{ overflowX: 'hidden', width: 'fit-content', x: xMotion }}
                        animate={false}
                    >
                        {children}
                    </motion.div>
                </div>
                <TemplateScrollbar
                    scrollPosition={x}
                    contentWidth={scrollWidth}
                />
            </Layout>
            <TemplateNextContent />
        </>
    )
}

export default Template